import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "correctPredictions"]

  filter() {
    const eventId = this.selectTarget.value
    const url = new URL(window.location.href)

    if (eventId) {
      url.searchParams.set("event_id", eventId)
    } else {
      url.searchParams.delete("event_id")
    }

    if (this.hasCorrectPredictionsTarget && this.correctPredictionsTarget.checked) {
      url.searchParams.set("correct_predictions", "1")
    } else {
      url.searchParams.delete("correct_predictions")
    }

    window.Turbo.visit(url.toString())
  }
}
